customElements.define('component-mobile-menu-submenu', class MobileSubMenu extends HTMLElement {
  constructor() {
    super();
    this.TEXT_TYPE = 'fitting_room';
    this.SECTION_IMAGE_HERO = 'section_image';
    this.template = document.createElement('template');
    this.template.innerHTML = `
      <ul class="mobile-menu-section-container">
        <div class="mobile-menu-submenu">
        </div>
      </ul>
    `;
  }

  connectedCallback() {
    this.appendChild(this.template.content.cloneNode(true));
    this.classList.add('mobile-menu-section-container');
    // DOM elements
    this.subMenu = this.querySelector('.mobile-menu-submenu');
    this.renderSubMenus();
    this.renderSectionImages();
  }

  normalizeKey(key) {
    return key.replace(/\W/g, '-').toLowerCase();
  }

  renderSubMenus() {
    if (this.items && this.items.length) {
      this.items.forEach((item) => {
        const ul = document.createElement('ul');
        const liHeader = this.createSubMenuItem(item, true);
        ul.appendChild(liHeader);
        if (item.subItems && item.subItems.length) {
          item.subItems.forEach((subItem) => {
            const li = this.createSubMenuItem(subItem, false);
            ul.appendChild(li);
          });
        }
        this.subMenu.appendChild(ul);
      });
    }
  }

  createSubMenuItem(item, header) {
    const li = document.createElement('li');
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(item.url)) {
      this.baseUrlSplit = window.location.host.split('.')
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      item.url = `https://www.${this.baseUrl}${item.url}`;
    }
    li.setAttribute("data-attribute", this.normalizeKey(item.title));
    li.setAttribute("id", this.normalizeKey(item.title));

    const a = document.createElement('a');
     if (header) {
      a.classList.add('mobile-menu-main-submenu-link');
    } else {
      a.classList.add('mobile-menu-second-submenu-link');
    }
    a.setAttribute("href", item.url || '#');

    const span = document.createElement('span');
    span.innerHTML = item.title;

    a.appendChild(span);
    li.appendChild(a);
    return li;
  }

  renderSectionImages() {
    if (this.sectionImages && this.sectionImages.length) {
      const div = document.createElement('div');
      div.classList.add('mobile-menu-section-images-container');
      this.sectionImages
        .filter((item) => item.type !== this.SECTION_IMAGE_HERO)
          .forEach((item) => {
            let cardEL;
            if (item.type === this.TEXT_TYPE) {
              cardEL = this.createTextCard(item);
            } else {
              cardEL = this.createImageCard(item);
            }
            div.appendChild(cardEL);
          });

      this.subMenu.appendChild(div);
    }
  }

  createTextCard(item) {
    const textComponent = document.createElement('component-card-text');
    textComponent.setAttribute("heading", item.heading);
    textComponent.setAttribute("sub-heading", item.subheading);
    textComponent.setAttribute("link", item.link);
    return textComponent;
  }

  createImageCard(item) {
    const imageComponent = document.createElement('component-card-image');
    imageComponent.setAttribute("heading", item.heading);
    imageComponent.setAttribute("link", item.link);
    imageComponent.setAttribute("image", item.image);
    imageComponent.setAttribute("imageAlt", item.imageAlt || '');
    if (item.pictureHtml) imageComponent.pictureHtml = item.pictureHtml;
    imageComponent.setAttribute("ctaText", item.ctaText);
    if (item.headingCA) imageComponent.setAttribute("headingCA", item.headingCA);
    if (item.linkCA) imageComponent.setAttribute("linkCA", item.linkCA);
    if (item.imageCA) imageComponent.setAttribute("imageCA", item.imageCA);
    if (item.imageAltCA) imageComponent.setAttribute("imageAltCA", item.imageAltCA);
    if (item.pictureHtmlCA) imageComponent.pictureHtmlCA = item.pictureHtmlCA;
    if (item.ctaTextCA) imageComponent.setAttribute("ctaTextCA", item.ctaTextCA);
    return imageComponent;
  }
});



